import React from 'react'
import '../Biochemistry/Biochemistry.css'
import common from '../../../assets/common.jpg'
import MegaNavbar from '../../../Components/MegaNavbar'

import DrAaliyaMinhazCV from '../../../assets/CVs/Chemistry/DrAaliyaMinhazCV.pdf'
import DrAsmaNasrullah_CV from '../../../assets/CVs/Chemistry/DrAsmaNasrullah_CV.pdf'
import DrFatimaKhitab_Cv from '../../../assets/CVs/Chemistry/DrFatima Khitab_Cv.pdf'
import DrFatimaJaved_CV from '../../../assets/CVs/Chemistry/DrFatimaJaved_CV.pdf'
import DrHajeraGul_Cv from '../../../assets/CVs/Chemistry/DrHajeraGul_Cv.pdf'
import DrMAMOONAALAM_Cv from '../../../assets/CVs/Chemistry/DrMAMOONAALAM_Cv.pdf'

import DrNaheedBibi_Cv from '../../../assets/CVs/Chemistry/DrNaheedBibi_Cv.pdf'
import DrTasmia_Cv from '../../../assets/CVs/Chemistry/DrTasmia_Cv.pdf'
import DrZahida_CV from '../../../assets/CVs/Chemistry/DrZahida_CV.pdf'

// import MsSADIAHABIBRESUME from '../../../assets/CVs/Biochemistry/DrMAMOONAALAM_Cv.pdf'
import Footer from '../../../Components/Footer'

const Chemistry = () => {
  return (
    <>
    <MegaNavbar/>
     <section id="team" className="team section-bg">
        <div className="container">

      <div className="section-title">
        <h2>Chemistry</h2>
       
        <p> Faculty of Chemistry.</p>
      </div>

      <div className="row">

      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Aaliya Minhaz </h4>
              <span>Assistant Professor Department of Chemistry</span>
              <p>Assistant Professor Department of Chemistry Shaheed Benazir Bhutto Women University Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i>  aaliyachem@sbbwu.edu.pk  </p>
              <div className="social">
                <a href={DrAaliyaMinhazCV}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
 


      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Asma Nasrullah (Gold Medalist)  </h4>
              <span>Lecturer Department of Chemistry</span>
              <p>Lecturer at the Department of Chemistry, Shaheed Benazir Bhutto Women University Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> dr.asmanasrullah@sbbwu.edu.pk    </p>
              <div className="social">
                <a href={ DrAsmaNasrullah_CV}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
 


      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Fatima Khitab </h4>
              <span> Department of Chemistry</span>
              <p> Assistant Professor Department of Chemistry, Shaheed Benazir Bhutto Women University Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> fatimakhitab@sbbwu.edu.pk    </p>
              <div className="social">
                <a href={DrFatimaKhitab_Cv}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
 


      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Fatima Javed  </h4>
              <span>Assistant Professor Department of Chemistry</span>
              <p> Assistant Professor (Inorganic/ Analytical Chemistry) , Shaheed Benazir Bhutto Women University Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> fatimajaved@sbbwu.edu.pk     </p>
              <div className="social">
                <a href={DrFatimaJaved_CV}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>


      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Hajera Gul  </h4>
              <span>Assistant Professor Department of Chemistry</span>
              <p> Assistant Professor at Department of Chemistry, Shaheed Benazir Bhutto Women University, Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> drhajeragul@sbbwu.edu.pk  </p>
              <div className="social">
                <a href={ DrHajeraGul_Cv}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>


      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Mamoona Alam  </h4>
              <span>Lecturer Department of Chemistry</span>
              <p> Lecturer at Department of Chemistry, Shaheed Benazir Bhutto Women University, Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> oxacine@gmail.com   </p>
              <div className="social">
                <a href={DrMAMOONAALAM_Cv}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>


      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>Dr. Naheed Bibi </h4>
              <span>Assistant Professor Department of Chemistry</span>
              <p> Assistant Professor Department of Chemistry, Shaheed Benazir Bhutto Women University, Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i> naheedics@gmail.com   </p>
              <div className="social">
                <a href={DrNaheedBibi_Cv}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
 
      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4> Dr. Tasmia  </h4>
              <span>Lecturer Department of Chemistry</span>
              <p> Lecturer at Department of Chemistry, Shaheed Benazir Bhutto Women University, Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i>  dr.tasmia@sbbwu.edu.pk  </p>
              <div className="social">
                <a href={DrTasmia_Cv}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>

 
      <div className="col-lg-6">
          <div className="member d-flex align-items-start">
            <div className="teampic"><img src={common} className="img-fluid" alt="" /></div>
            <div className="member-info">
              <h4>  Dr. Zahida Wasil </h4>
              <span>Lecturer Department of Chemistry</span>
              <p> Lecturer at Department of Chemistry, Shaheed Benazir Bhutto Women University, Peshawar </p>
                 <p className='my-icon'><i className="bi bi-envelope-at-fill"></i>  dr.tasmia@sbbwu.edu.pk  </p>
              <div className="social">
                <a href={DrZahida_CV}><i class="bi bi-file-earmark-person-fill"></i></a>
                <a href=""><i className="bi bi-google"></i></a>
                <a href=""><i className="bi bi-linkedin"></i></a>
               </div>
            </div>
          </div>
        </div>
        
        {/* Repeat the above structure for other team members */}

      </div>

    </div>
  </section>
      <Footer/>
    </>
  )
}

export default Chemistry
